import PropTypes from 'prop-types';

export const CountryPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  countryCode: PropTypes.string,
  lastUpdate: PropTypes.number,
});

export const RegionPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  countryId: PropTypes.number,
  lastUpdate: PropTypes.number,
  country: CountryPropType,
});

export const CityPropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  regionId: PropTypes.number,
  lastUpdate: PropTypes.number,
  geographicZoneId: PropTypes.number,
  region: RegionPropType,
});

export const AddressPropType = PropTypes.shape({
  id: PropTypes.number,
  address: PropTypes.string,
  address2: PropTypes.string,
  district: PropTypes.string,
  cityId: PropTypes.number,
  districtId: PropTypes.number,
  postalCode: PropTypes.string,
  phone: PropTypes.string,
  city: CityPropType,
});

export const IdentificationTypePropType = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  identificationInCountry: PropTypes.string,
});

export const CustomerPropType = PropTypes.shape({
  id: PropTypes.number,
  firstName: PropTypes.string,
  lastName: PropTypes.string,
  addressId: PropTypes.number,
  address: AddressPropType,
  idDocumentNumber: PropTypes.string,
  idCountryOfOrigin: PropTypes.string,
  gender: PropTypes.string,
  dob: PropTypes.string,
  identificationTypeId: PropTypes.number,
  identificationType: IdentificationTypePropType,
  mobilePhone: PropTypes.string,
  homePhone: PropTypes.string,
  workPhone: PropTypes.string,
  fax: PropTypes.string,
  email: PropTypes.string,
  fullName: PropTypes.string,
  discountCode: PropTypes.string,
});

export const DiscountCodeAuthorizerProptype = PropTypes.shape({
  id: PropTypes.number,
  customerId: PropTypes.number,
  customer: CustomerPropType,
  active: PropTypes.bool,
  createDate: PropTypes.number,
});
